<div class="site-container" style="margin-top: 60px">
  <div class="grid">
    <div class="col-12 md:col-3">
      <div class="account-navigation">
        <h2 class="account-navigation-title">Your Account</h2>
        <ul class="account-navigation-wrap">
          <a routerLink="/my-account/orders" routerLinkActive="active" ariaCurrentWhenActive="page">
            <li class="account-navigation-item">
              <img src="assets/img/icons/box.svg" alt="Orders" />
              Orders
            </li>
          </a>
          <a
            routerLink="/my-account/gift-cards"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
          >
            <li class="account-navigation-item">
              <img src="assets/img/icons/tag-2.svg" alt="Gift Cards" />
              Gift Cards
            </li>
          </a>
        </ul>
      </div>
      @if (userStore.isAdmin()) {
        <div class="account-navigation mt-4">
          <h2 class="account-navigation-title">Admin management</h2>
          <ul class="account-navigation-wrap">
            <a
              routerLink="/my-account/admin/users"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
            >
              <li class="account-navigation-item">
                <img src="assets/img/icons/user-dark.svg" alt="Users" />
                Users
              </li>
            </a>
            @if (canViewOrders()) {
              <a
                routerLink="/my-account/admin/orders"
                routerLinkActive="active"
                ariaCurrentWhenActive="page"
              >
                <li class="account-navigation-item">
                  <img src="assets/img/icons/box.svg" alt="Orders" />
                  Orders
                </li>
              </a>
            }
            @if (canViewStoreCredits()) {
              <a
                routerLink="/my-account/admin/store-credits"
                routerLinkActive="active"
                ariaCurrentWhenActive="page"
              >
                <li class="account-navigation-item">
                  <img src="assets/img/icons/box.svg" alt="Orders" />
                  Store Credits
                </li>
              </a>
            }
            <a
              routerLink="/my-account/admin/reports"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
            >
              <li class="account-navigation-item">
                <img src="assets/img/icons/reports.svg" alt="Reports" />
                Reports
              </li>
            </a>
          </ul>
        </div>
      }
    </div>
    <div class="col-12 md:col-9">
      <div class="account-content">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
